import useSelectedPassengerClass from "@CheckOrder/features/classPicker/hooks/useSelectedPassengerClass";
import PassengerClassSelectModal
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/components/PassengerClassSelectModal";
import useAdditionalPassengerClassSelectModal
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useAdditionalPassengerClassSelectModal";
import ClassPickerDropdown from "@CheckOrder/features/classPicker/components/ClassPickerDropdown";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

interface SingleClassPickerProps {
    passengerId: number,
}

function SingleClassPicker({passengerId}: SingleClassPickerProps) {
    const {singleRoutePassengerClasses} = useAppSelector((state) => (state.checkOrder.ticket.passengerClasses))
    const {
        selectedPassengerClass,
        setSelectedPassengerClass,
    } = useSelectedPassengerClass(passengerId, singleRoutePassengerClasses)

    const {
        dialogRef,
        closeModal,
        newlySelectedPassengerClass,
        setNewlySelectedPassengerClass,
    } = useAdditionalPassengerClassSelectModal()

    return (
        <>
            <PassengerClassSelectModal
                dialogRef={dialogRef}
                closeModal={closeModal}
                passengerId={passengerId}
                selectedPassengerClass={newlySelectedPassengerClass}
                setSelectedPassengerClass={setSelectedPassengerClass}
            />
            <ClassPickerDropdown
                passengerId={passengerId}
                availablePassengerClassesGroups={singleRoutePassengerClasses}
                selectedPassengerClass={selectedPassengerClass}
                setSelectedPassengerClass={setSelectedPassengerClass}
                setNewlySelectedPassengerClass={setNewlySelectedPassengerClass}
                showSelectedClassDetails
            />
        </>
    );
}

export default SingleClassPicker